/* ===== Horizon Slideshow iOS Safari Fix ===== */
(function () {
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) &&
                !window.MSStream;

  if (!isIOS) return;

  function reInitHorizonSlideshow() {
    document.querySelectorAll('.horizon-slideshow').forEach(slideshow => {
      slideshow.style.display = 'none';
      slideshow.offsetHeight; // force reflow
      slideshow.style.display = '';
    });
  }

  window.addEventListener('load', () => {
    setTimeout(reInitHorizonSlideshow, 400);
  });

  window.addEventListener('orientationchange', () => {
    setTimeout(reInitHorizonSlideshow, 300);
  });
})();